import RadioMain from './Radio';
import RadioGroup from './RadioGroup';
const RadioTemp = RadioMain;
RadioTemp.Group = RadioGroup; // To add typings

const Radio = RadioTemp;
export { Radio };
export { RadioContext } from './RadioGroup';
//# sourceMappingURL=index.js.map